
<!-- Page 2 - Introduction 2 -->

<template>
  <div class="page1 animated fadeIn">
    <div class="container">
      <div class="left-side">
        <h3 class="title">{{items.intro2.title}}</h3>
        <p v-html="items.intro2.text"></p>
      </div>
      <div class="right-side">
        <img src="media/intros/chart_1.png" />
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {

    };
  },

  computed: {
    location() {
      return this.$store.state.scormLMS.location
    },
    items() {
      return this.$store.state.items
    }
  },

  methods: {
    checkCue() {
      //BOILERPLATE FOR RUNNING AN INTERVAL
      // var self = this
      // if(Math.floor(self.$refs.audio1.currentTime) == 3){
      //   self.vis1 = "visible"
      // }
    },
    runInterval() {
      //BOILERPLATE FOR RUNNING AN INTERVAL
      this.interval = setInterval(this.checkCue, 100);
    }
  },
  mounted() {
    //JIRA LOCATION
    this.$store.commit("scormLMS/changeUserLocation", "MA KPIs: Page 1");
    this.$store.commit('backFalse');
  },
  beforeDestroy() {
    //BOILERPLATE FOR RUNNING AN INTERVAL
    clearInterval(this.interval);
  },
  components: {},
  props: []
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// Page1.vue?51104f01